<template>
    <form class="form-horizontal" v-if="config">

        <div class="form-group">
            <label for="mbv_tensao_12_24" class="col-sm-4 control-label">TEMPO PARA DETECTAR CHOQUE:</label>
            <div class="col-sm-3">
                <input type="number" v-model="config.msr_tempo_para_choque" class="form-control input-sm" id="mbv_tensao_12_24">
            </div>
        </div>

        <div class="form-group">
            <label for="mbv_tensao_12" class="col-sm-4 control-label">SENSIBILIDADE DE MOVIMENTO:</label>
            <div class="col-sm-3">
                <input type="number" v-model="config.msr_sensibilidade_move" class="form-control input-sm" id="mbv_tensao_12">
            </div>
        </div>

        <div class="form-group">
            <label for="mbv_tensao_24" class="col-sm-4 control-label">SENSIBILIDADE DE CHOQUE:</label>
            <div class="col-sm-3">
                <input type="number" v-model="config.msr_sensibilidade_choque" class="form-control input-sm" id="mbv_tensao_24">
            </div>
        </div>

        <div class="form-group">
            <label for="mbv_ign_alta" class="col-sm-4 control-label">SENSIBILIDADE DE COLISÃO:</label>
            <div class="col-sm-3">
                <input type="number" v-model="config.msr_sensibilidade_colisao" class="form-control input-sm" id="mbv_ign_alta">
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-4 col-sm-8">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import {Suntech} from "../../../../class";
    import {Bus} from '../../../../class/bus';
    export default {
        name: "Acelerometro",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendAcelerometro(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
